export interface GlobalInitialState {
  countryCode: string;
  languageCode: string;
}

export type SetCountryCodeAction<T, U> = (countryCode: T) => U;
export type SetLanguageCodeAction<T, U> = (languageCode: T) => U;

export const enum GlobalActionTypes {
  SET_COUNTRY_CODE = 'SET_COUNTRY_CODE',
  SET_LANGUAGE_CODE = 'SET_LANGUAGE_CODE'
}
